"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var navbarContext_1 = require("./navbarContext");
var user_1 = require("./user");
var search_1 = require("./search");
var logo_1 = require("./logo");
var navigation_1 = require("./navigation");
var drawer_1 = require("./drawer");
var burger_1 = require("./burger");
var bar_1 = require("./bar");
var lock_1 = require("./lock");
var divider_1 = require("./divider");
var networkActivity_1 = require("./networkActivity");
var toggler = function (menu, setMenu) { return function (id) {
    var _a;
    setMenu(__assign(__assign({}, Object.keys(menu).reduce(function (acc, r) {
        return (acc[r] = false);
    }, {})), (_a = {}, _a[id] = !menu[id], _a)));
}; };
exports.Navbar = function (props) {
    var _a = react_1.useState({}), menu = _a[0], setMenu = _a[1];
    var isOpen = function (id) {
        return !!menu[id];
    };
    var toggleMenu = toggler(menu, setMenu);
    var boxed = props.boxed, nav = props.nav, currentUser = props.currentUser, _b = props.search, search = _b === void 0 ? { url: "", q: "" } : _b, lock = props.lock, networkRequestActive = props.networkRequestActive, networkAvailable = props.networkAvailable, showNetworkActivity = props.showNetworkActivity, showLock = props.showLock, showSearch = props.showSearch;
    var ctx = {
        boxed: boxed,
        nav: nav,
        currentUser: currentUser,
        search: search,
        lock: lock,
        networkRequestActive: networkRequestActive,
        networkAvailable: networkAvailable,
        isOpen: isOpen,
        toggleMenu: toggleMenu
    };
    var _c = react_1.useState(window.innerWidth >= 768 ? "header" : "drawer"), display = _c[0], setDisplay = _c[1];
    var _d = react_1.useState(false), showDrawer = _d[0], setDrawer = _d[1];
    react_1.useEffect(function () {
        var onResize = function (e) {
            if (window.innerWidth >= 768) {
                display !== "header" && setDisplay("header");
                return;
            }
            display !== "drawer" && setDisplay("drawer");
        };
        window.addEventListener("resize", onResize);
        return function () { return window.removeEventListener("resize", onResize); };
    }, [display]);
    var isMobileDisplay = display === "drawer";
    return (react_1.default.createElement(navbarContext_1.NavContext.Provider, { value: ctx },
        react_1.default.createElement(bar_1.Bar, { boxed: props.boxed },
            react_1.default.createElement(creator_ui_1.Flexbox, { alignItems: "center", style: { flex: isMobileDisplay ? 1 : 0, height: 70 } },
                isMobileDisplay ? react_1.default.createElement(burger_1.Burger, __assign({}, { showDrawer: showDrawer, setDrawer: setDrawer })) : null,
                react_1.default.createElement(creator_ui_1.Flexbox, { flex: "0", pl: 3, pr: 2 },
                    react_1.default.createElement(creator_ui_1.Flexbox, { as: "a", href: "/", target: "_parent" },
                        react_1.default.createElement(logo_1.Logo, null))),
                react_1.default.createElement(creator_ui_1.Flexbox, { style: { flex: isMobileDisplay ? 1 : 0 }, px: 2 },
                    react_1.default.createElement(search_1.SearchBar, { q: search.q, url: search.url, showSearch: showSearch })),
                !isMobileDisplay ? (react_1.default.createElement(react_1.default.Fragment, null,
                    showLock ? (react_1.default.createElement(creator_ui_1.Flexbox, { px: 2 },
                        react_1.default.createElement(lock_1.Lock, { lock: lock }))) : null,
                    react_1.default.createElement(creator_ui_1.Flexbox, { px: 2 },
                        react_1.default.createElement(networkActivity_1.NetworkActivity, { showActivity: showNetworkActivity, isActive: networkRequestActive })))) : null),
            !isMobileDisplay ? (react_1.default.createElement(creator_ui_1.Flexbox, { flex: "1", justifyContent: "flex-end", px: 3 },
                react_1.default.createElement(navigation_1.Navigation, { nav: nav }),
                currentUser ? react_1.default.createElement(user_1.Admin, { name: currentUser.firstName, profileImg: currentUser.profileImage }) : null)) : null),
        isMobileDisplay ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(drawer_1.Overlay, { style: {
                    display: showDrawer ? "block" : "none"
                }, onClick: function () { return setDrawer(false); } }),
            react_1.default.createElement(drawer_1.Drawer, { style: {
                    transform: showDrawer
                        ? "translate3d(0,0,0)"
                        : "translate3d(-340px,0,0)"
                } },
                react_1.default.createElement(creator_ui_1.Flexbox, { px: 3, py: "11px" },
                    react_1.default.createElement(logo_1.Logo, null)),
                react_1.default.createElement(divider_1.Divider, null),
                react_1.default.createElement(creator_ui_1.Box, { as: "ul", p: 0, m: 0 }, nav.map(function (r, i) { return (react_1.default.createElement(drawer_1.DrawerItem, { key: "nav-" + r.label + "-i", item: r })); }))))) : null));
};
